import { render, staticRenderFns } from "./VerifyLegacyBox.vue?vue&type=template&id=6b1949ae&lang=pug&"
import script from "./VerifyLegacyBox.vue?vue&type=script&lang=js&"
export * from "./VerifyLegacyBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports